module.exports = __webpack_public_path__ + "img/sgrm.91d35b5c.png";